/**
 * Sanitize and validate URL before using in Vue templates (v-bind:href)
 * - Removes javascript:, data:, and other unsafe protocols.
 * - Only allows http(s) and allowed hosts.
 * - Safe for use with v-html or :href in Vue.
 */
export function safeUrl(url) {
  if (typeof url !== 'string') return '';

  try {
    const parsed = new URL(url, window.location.origin);

    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return '';
    }
    const allowedHosts = [window.location.hostname, 'getac.sharepoint.com', 'getac.my.salesforce.com', 'test.salesforce.com'];
    if (!allowedHosts.includes(parsed.hostname)) {
      return '';
    }

    return parsed.href;
  } catch(e) {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/helpers/vue-url.js